interface NoSubscriptionModalProps {
  open: boolean
  /** Primary CTA — reset the funnel and head into the quiz. */
  onTakeQuiz: () => void
  /** Secondary — sign out so a different account can be used. */
  onTryAnother: () => void
}

/**
 * Forced bottom-sheet shown after sign-in when the account has no active
 * subscription. Non-dismissible (no close / backdrop-dismiss) — the user must
 * either start the quiz or switch accounts. Slides up over the dimmed sign-in
 * screen behind it.
 */
export function NoSubscriptionModal({ open, onTakeQuiz, onTryAnother }: NoSubscriptionModalProps) {
  if (!open) return null

  return (
    <div
      data-slot="no-subscription-modal"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 flex flex-col justify-end"
      style={{ fontFamily: '"Red Hat Text Variable", sans-serif' }}
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-dark-base/80 backdrop-blur-[10px] animate-in fade-in"
      />

      <div className="animate-in slide-in-from-bottom relative mx-auto flex w-full max-w-app flex-col items-center gap-6 rounded-t-[24px] bg-dark-surface px-4 pb-4 pt-8 text-center text-purple-light duration-300">
        <div className="flex w-full flex-col gap-2 text-center">
          <h2 className="font-display text-2xl font-medium text-purple-light">
            Looks like you don’t have an account yet
          </h2>
          <p className="text-base leading-snug text-purple-light/70">
            We couldn’t find a profile linked to this login. Take a quick quiz to create your
            personal guidance profile — it only takes 2 minutes.
          </p>
        </div>

        <div className="flex w-full flex-col gap-2.5">
          <button
            type="button"
            onClick={onTakeQuiz}
            className="flex h-14 w-full items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent text-base font-semibold text-white transition-opacity hover:opacity-90"
          >
            Take the quiz
          </button>
          <button
            type="button"
            onClick={onTryAnother}
            className="flex h-14 w-full items-center justify-center rounded-full bg-purple-light/10 text-base font-semibold text-white transition-colors hover:bg-purple-light/15"
          >
            Try another account
          </button>
        </div>
      </div>
    </div>
  )
}
